import { QuickShipsActions } from "../../types";

export function append(
  items: [any],
  tags: [any],
  acceptWrongItems: boolean,
): any {
  items.forEach((item) => {
    item.tags = tags.filter((tag) => tag.item_number === item.item.number);
  });

  return { type: QuickShipsActions.ItemAppend, items, acceptWrongItems };
}

export function override(
  item: any,
  override: boolean,
  override_reason: any,
): any {
  return {
    type: QuickShipsActions.ItemOverride,
    item,
    override,
    override_reason,
  };
}

export function remove(item: any) {
  return { type: QuickShipsActions.ItemRemove, item };
}
